import {
  Button,
  Grid,
  Heading,
  IconCheckLine,
  InlineList,
  Pill,
  Text,
} from "@instructure/ui";
import { t } from "i18next";
import { useContext } from "react";
import { Link } from "react-router-dom";
import { FeatureContext } from "../../../../../utils/Context";
import SectionButton from "./SectionButton";

const SectionHeader = ({
  section,
  cardColor,
  handleSectionSelect,
  reflectionTemplates,
  sectionRefTemplate,
}) => {
  const features = useContext(FeatureContext);
  const finalizeFlag =
    features.find((f) => f.name === "finalize_results_flag")?.value === "TRUE";

  return (
    <Grid startAt="medium" rowSpacing="small">
      <Grid.Row>
        <Grid.Col>
          <SectionButton
            aria-label={t("dashboard.offeringCardAria", {
              code: section.offering.code,
              term: section.term?.name,
            })}
            onClick={() => handleSectionSelect(section)}
          >
            <Heading as="h3" level="h4">
              <Text wrap="break-word">
                <span style={{ color: cardColor }}>
                  {section.name ??
                    section.offering.code ??
                    t("dashboard.missingSectionName")}
                </span>
                <InlineList delimiter="pipe">
                  <InlineList.Item>{section.offering.code}</InlineList.Item>
                  <InlineList.Item>{section.term?.name}</InlineList.Item>
                </InlineList>
              </Text>
            </Heading>
          </SectionButton>
        </Grid.Col>
        {finalizeFlag && (
          <Grid.Col width={5} textAlign="end">
            {section.finalized ? (
              <Pill color="success" renderIcon={<IconCheckLine />}>
                {t("finalizeCourse.finalized")}
              </Pill>
            ) : (
              <Link
                to="/scores/home"
                state={{ section, reflectionTemplates, sectionRefTemplate }}
              >
                <Button size="small">{t("finalizeCourse.finalize")}</Button>
              </Link>
            )}
          </Grid.Col>
        )}
      </Grid.Row>
    </Grid>
  );
};

export default SectionHeader;
